export class SalesSummaryTotal {

    /** Total sale prices for all bhph sales within the given time frame. */
    public bhph: number = 0

    /** Total sale prices for all outside finance sales within the given time frame. */
    public outside: number = 0

    /** Total sale prices for all whoelsale sales within the given time frame. */
    public wholesale: number = 0

    /** Total sale prices for all cash sales within the given time frame. */
    public cash: number = 0

    /** Total sale prices for all bhph, outside, wholesale and cash sales. */
    public total: number = 0

    /** Total of all bhph sale payments within the given time frame. */
    public payments: number = 0

}
